import { useMemo } from 'react'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { useRequestContext } from '../hooks/RequestContext'
import { mapQuoteItemsToDesignRows } from '../utils/quoteItems'
import type { RequestTabId } from '../types'
import { RequestCanvas } from './RequestCanvas'
import { RequestTabShell } from './RequestTabShell'
import { Checkout } from './tabs/Checkout'
import { SummaryTab } from './tabs/SummaryTab'

const ExplorePanel = () => {
  const { t } = useLocalization()
  const { publicId, quote, quoteItems, isDemo } = useRequestContext()
  const allDesigns = useMemo(
    () => mapQuoteItemsToDesignRows(quoteItems, t),
    [quoteItems, t]
  )

  return (
    <RequestTabShell
      loadingMessage={t('Loading canvas...', 'Laddar canvas...')}
      requireQuoteItems
    >
      {quote ? (
        <RequestCanvas
          allDesigns={allDesigns}
          publicId={publicId}
          quoteId={isDemo ? undefined : quote.id}
          isReadOnly={Boolean(isDemo)}
        />
      ) : null}
    </RequestTabShell>
  )
}

export const RequestTabPanels = ({ tab }: { tab: RequestTabId }) => {
  const { t } = useLocalization()

  switch (tab) {
    case 'explore':
      return <ExplorePanel />

    case 'checkout':
      return (
        <RequestTabShell
          loadingMessage={t('Loading checkout...', 'Laddar kassa...')}
        >
          <Checkout />
        </RequestTabShell>
      )

    case 'delivery':
      return <SummaryTab />
  }
}
